import { render, staticRenderFns } from "./create-vista-conf-popup.html?vue&type=template&id=097c0e7a&scoped=true&external"
import script from "./create-vista-conf-popup.js?vue&type=script&lang=js&external"
export * from "./create-vista-conf-popup.js?vue&type=script&lang=js&external"
import style0 from "./create-vista-conf-popup.scss?vue&type=style&index=0&id=097c0e7a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097c0e7a",
  null
  
)

export default component.exports